export const ETA_TOOLTIP_MOUSE_ENTER_DELAY = 100;
export const DEFAULT_HOVER_DELAY = 150;
